import axios from "axios";
import { VITE_BASE_URL } from "../../config";

// NOTE: do not set Access-Control-Allow-* here. Those are response headers; as
// request headers they make the browser add them to the CORS preflight, which
// the gateway rejects (only Authorization/Content-Type are allowed) — breaking
// requests like the medication CSV upload.
const instance = axios.create();

instance.interceptors.request.use(
  (config: any) => {
    const token = getLocalAccessToken();

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.setItem("refreshToken", "");
      localStorage.setItem("access_token", "");
      localStorage.setItem("isAuth", "");
    }
    return Promise.reject(error);
  },
);

const getLocalAccessToken = () => {
  const accessToken = localStorage.getItem("access_token");
  return accessToken;
};

const getLocalRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return refreshToken;
};

const truncateText = (value: string, maxLength: number) => {
  if (!value) return "";
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength).trim()}...`;
};

// Fetch a signed Jitsi meeting JWT from master-service. Providers get a moderator
// token (bypass lobby + admit others); patients get a non-moderator token. The
// bridge verifies this HS256 token — the raw Keycloak access_token no longer works.
const fetchJitsiToken = async (room?: string): Promise<string | undefined> => {
  try {
    const res = await instance.get(
      `${VITE_BASE_URL}/api/master/v1/video/jitsi-token`,
      { params: room ? { room } : {} },
    );
    return res?.data?.data;
  } catch (e) {
    console.error("[jitsi] failed to fetch meeting token", e);
    return undefined;
  }
};

export {
  fetchJitsiToken,
  getLocalAccessToken,
  getLocalRefreshToken,
  instance,
  truncateText,
};
